import * as types from './mutation-types'
import {LOAD_QVCT_POPULATION} from "./mutation-types";
export default {
  [types.LOAD_QVCT_POPULATION](state, data) {
    state.qvctPopulation = data
  },

}
